import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { CustomLayout } from 'Components/UI/CustomLayout';
import tabRegistry from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/tabRegistry';
import useUserContext from 'Context/UserContext';
import useListDetailActions from 'Components/UI/ListDetailView/useListDetailActions';
import { useListContextState } from 'Components/UI/ListDetailView/ListContext';
import { useSelectionContextState } from 'Components/UI/ListDetailView/SelectionContext';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { useMeetingContext } from 'Context/MeetingContext';
import useMissionControl from '../useMissionControl';

const styles = () => ({
  root: {},
});

const DefaultDetail = ({
  className,
  classes,
}) => {
  const { collection: listColl } = useListContextState();
  const { selectedResourceSelfLink } = useSelectionContextState();
  const { userResource, agentResource } = useUserContext();
  const { householdResource } = useSimpleHousehold();
  const { selectMeetingResource } = useMissionControl();
  const { selectResource } = useListDetailActions();
  const { meetingResource } = useMeetingContext();

  const selectFirstMeeting = async (coll) => {
    if (coll.resources().empty()) {
      return;
    }

    const [firstMeetingResource] = listColl;
    await selectMeetingResource(firstMeetingResource);
    selectResource(firstMeetingResource, coll);
  };

  React.useEffect(() => {
    if (listColl !== null && !selectedResourceSelfLink) {
      selectFirstMeeting(listColl);
    }
  }, [listColl, selectedResourceSelfLink]);

  const filteredTabs = Object.entries(tabRegistry)
    .filter(([, tab]) => tab.hidden === undefined || !tab.hidden({ agentResource, userResource, householdResource }));

  const filteredTabRegistry = Object.fromEntries(filteredTabs);

  return (
    <CustomLayout
      className={classNames(classes.root, className)}
      layoutLink={userResource?.relationship('missionControlLayout').link('related')}
      tabRegistry={filteredTabRegistry}
      test="mission-control-custom-layout"
      contentKey={meetingResource?.id()}
    />
  );
};

DefaultDetail.defaultProps = {
  className: '',
};

DefaultDetail.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DefaultDetail);
